export default {
  breadcrumb: {
    catalog: 'Katalog',
  },
  by: 'od',
  preorderBadge: 'Předobjednávka',
  metaDescription: 'Kupte si {name} — okamžité doručení klíče na KeyzoStore.',
  price: {
    soldOut: 'Vyprodáno',
  },
  unavailable: 'Tato nabídka již není dostupná.',
  addToCart: {
    inCart: 'V košíku · {qty}',
  },
  share: 'Sdílet',
  notFound: {
    title: 'Tuto hru jsme nenašli',
    body: 'Odkaz může být starý, nebo byla nabídka odstraněna.',
    action: 'Procházet katalog',
  },
  chips: {
    countries: 'Dostupné v {count} zemích',
    metacritic: 'Metacritic {score}',
  },
  delivery: {
    label: 'Doručení',
    hint: 'Klíč se objeví ve vašich objednávkách a v e-mailové schránce.',
  },
  stock: {
    label: 'Sklad',
    keys: 'klíčů z aktivních nabídek',
  },
  region: {
    label: 'Region',
  },
  gallery: {
    label: 'Snímky obrazovky',
    show: 'Otevřít snímek {n}',
    counter: '{current} / {total}',
  },
  description: {
    label: 'Popis',
    showMore: 'Zobrazit více',
    showLess: 'Zobrazit méně',
    noDescription: 'Pro tento titul není k dispozici žádný popis.',
  },
  details: {
    title: 'Podrobnosti',
    developers: 'Vývojáři',
    publishers: 'Vydavatelé',
    releaseDate: 'Datum vydání',
    languages: 'Jazyky',
    platform: 'Platforma',
  },
  related: {
    title: 'Mohlo by se vám líbit',
    fallbackTitle: 'Další z katalogu',
  },
  offers: {
    sectionTitle: 'Dostupné od prodejců',
    unknownSeller: 'Prodejce z tržiště',
    qty: 'Skladem: {count}',
    bestPriceBadge: 'Nejlepší cena',
    soldOutBadge: 'Vyprodáno',
    selectButton: 'Vybrat',
    soldOutButton: 'Vyprodáno',
  },
  wishlistAriaLabel: {
    add: 'Přidat do oblíbených',
    remove: 'Odebrat z oblíbených',
  },
  card: {
    wishlist: 'Uložit do oblíbených',
    delivery: {
      instant: 'Ihned',
      preorder: 'Předobjednávka',
      outOfStock: 'Není skladem',
    },
  },
};
